import { render, staticRenderFns } from "./MenuSectionsLandingBets.vue?vue&type=template&id=0e497820&scoped=true&"
import script from "./MenuSectionsLandingBets.vue?vue&type=script&lang=js&"
export * from "./MenuSectionsLandingBets.vue?vue&type=script&lang=js&"
import style0 from "./MenuSectionsLandingBets.vue?vue&type=style&index=0&id=0e497820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e497820",
  null
  
)

export default component.exports